"use client";
import { MSProductWithFullDetailWithVaraintPreset } from "@/util/query/product-query";
import dynamic from "next/dynamic";
import React from "react";
import { useMouseMovement } from "@/app/[lang]/MouseMovementContext";
import ProductPromotionHeader from "@/components/products/product-promotion-header";

const ProductPromotionCardListLoader = ({
    product,
    text,
    imagePriority,
    loc,
    shopCurrency,
    enableCompareButton = false,
    radiusStyle
}: {
    product: MSProductWithFullDetailWithVaraintPreset
    text: { [key: string]: string };
    imagePriority?: boolean;
    loc: string;
    shopCurrency: string;
    enableCompareButton: boolean;
    radiusStyle: any;
}) => {
    const { hasMouseMoved } = useMouseMovement();
    return hasMouseMoved || imagePriority ? (
        <div className="rounded-lg border bg-card text-card-foreground shadow-sm w-full md:rounded-3xl">
            <ProductPromotionHeader product={product} text={text} imagePriority={imagePriority} loc={loc} shopCurrency={shopCurrency} 
                enableCompareButton={enableCompareButton} radiusStyle={radiusStyle}
            /> 
        </div>
    ) : (
        <>
            {product.attributes?.displayName}
            {product.attributes?.description}
        </>
    );
};

export default ProductPromotionCardListLoader;
